$(document).ready(function() {
	//date picker
	$("#dt").datepicker({
		dateFormat: "M. d"
 	});

	//Get the current date in a dateobject
	var currentDate = new Date();
	//Offset the current date by how many days you need
	currentDate.setDate(currentDate.getDate() + 1);
	//Insert placeholder date
	
	jQuery("#dt").datepicker("setDate", currentDate);  
  
	// days
    $('.pc-days-plus').click(function() {
		var num = parseInt($('.pc-period-lasted').text());
	    if (num > 9) {
            //do nothing
        }
        else {
			$('.pc-period-lasted').text(num+1);
		}
	});
	$('.pc-days-minus').click(function() {
	  var num = parseInt($('.pc-period-lasted').text());
        if (num < 2) {
            //do nothing
        }
        else {
			$('.pc-period-lasted').text(num-1);
		}
	});
	
	// cycle
	 $('.pc-cycle-plus').click(function() {
	  var num = parseInt($('.pc-cycle-lasted').text());
        if (num > 44) {
            //do nothing
        }
        else {
			$('.pc-cycle-lasted').text(num+1);
		}
	});
	$('.pc-cycle-minus').click(function() {
	  var num = parseInt($('.pc-cycle-lasted').text());
        if (num < 12) {
            //do nothing
        }
        else {
			$('.pc-cycle-lasted').text(num-1);
		}
	});
	
	
	//inline cals
	$('#cal-ct').datepicker({
		numberOfMonths: 3, 
		showCurrentAtPos: 1,
		dayNamesMin: [ "S", "M", "T", "W", "T", "F", "S" ]
	});
	
	//flexslider
	$('.pc-product-slider').flexslider({
    	animation: "slide"
  	});
	
	

});
